/**
 * Locale helpers: full locale from app language, number separators for cell editors
 */

/**
 * Gets locale-specific number formatting settings
 */
export const getLocaleSettings = (locale: string) => {
  const language = locale.split('-')[0]

  const settings = {
    fi: { thousandSeparator: ' ', decimalSeparator: ',' },
    en: { thousandSeparator: ',', decimalSeparator: '.' },
    sv: { thousandSeparator: ' ', decimalSeparator: ',' }
  }

  return settings[language as keyof typeof settings] || settings.fi
}

/**
 * Full locale from app language (fi -> fi-FI)
 */
export const getLocaleFromLanguage = (language: string): string => {
  const localeMap: Record<string, string> = {
    fi: 'fi-FI',
    en: 'en-US',
    sv: 'sv-SE'
  }
  return localeMap[language] || 'fi-FI'
}
